import { render, staticRenderFns } from "./DashboardActiveFaultsTable.vue?vue&type=template&id=50f55e4a"
import script from "./DashboardActiveFaultsTable.vue?vue&type=script&lang=ts"
export * from "./DashboardActiveFaultsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports